import * as React from "react"
import * as Immutable from 'immutable'

import { Area } from "../../../types/types";

type Props = {
  areas: Immutable.List<Area>
}

export default (props: Props) : JSX.Element => (
  <>
    {props.areas.map((a) => (
      <a className="box box--clean box--highlight" href={a.path} key={a.id}>
        <div className='box__visual'>
          <div className='box__img' style={{ backgroundImage: `url(${a.headerImage.url})` }}>
          </div>
          <div className='box__overlay box__overlay--hover'></div>
        </div>
        <div className='box__body'>
          <h4 className='box__title'>{a.name}</h4>
          <h6 className='box__subtitle'>{a.rentalAdvertCount > 0 ? I18n.t('themes.amount_accommodations', { count: a.rentalAdvertCount }) : '\u00A0'}</h6>
        </div>
      </a>
    ))}
  </>
)
